import { createClient } from '@supabase/supabase-js';

// Anon/public key is meant to be shipped client-side (protected by Row
// Level Security on the Supabase project itself), same trust model as the
// Firebase client config in ./keys.jsx - just a different backend, used
// here only for admin auth + the profile photo upload.
const supabaseUrl = 'https://kgcozqqdtvelnqgaankj.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtnY296cXFkdHZlbG5xZ2FhbmtqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUxMjY2NTEsImV4cCI6MjEwMDcwMjY1MX0.IMCLxqWyI0qxzcSQ2lRxskgcHebmvINpu2figTGzFDM';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// One bucket per page's photo uploads (not shared) - each is a public
// bucket in the Supabase dashboard so getPublicUrl() resolves to a
// directly loadable image URL. Each needs its own RLS policies too
// (same shape as profile-images, just a different bucket_id).
export const PROFILE_BUCKET = 'profile-images';
export const EDUCATION_BUCKET = 'education-images';
export const EXPERIENCE_BUCKET = 'experience-images';

// Pulls the object path back out of a Supabase public URL, e.g.
// ".../storage/v1/object/public/education-images/education-123.png"
// -> "education-123.png" - needed to delete the file from storage,
// since remove() wants the path, not the full URL. Returns null for
// anything that isn't one of our own bucket URLs (blank field, or a
// manually-pasted external image) so callers know there's nothing to
// clean up in Storage.
export const storagePathFromUrl = (url, bucket) => {
  if (!url) return null;
  const marker = `/storage/v1/object/public/${bucket}/`;
  const idx = url.indexOf(marker);
  if (idx === -1) return null;
  return url.slice(idx + marker.length);
};

export default supabase;
